import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator from "@components/CustomTypography/Separator/Separator"
import {ReusableFeaturesGrid} from "@components/WebsiteRevamp/FeaturesGrid/Reusable/ReusableFeaturesGrid"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {getPosts} from "@config/modules"
import {backgroundColor} from "@customTypes/customTypes"
import {
	AdvancedSideAssetModuleType,
	MediaGalleryModuleType,
	MediaType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import Gallery from "@jsons/gallery.json"
import React from "react"

import GalleryPopup from "../GalleryPage/GalleryContainerSection/GalleryPopup"

// import styles from "./GallerySection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
	gallery: MediaGalleryModuleType
	background?: backgroundColor
}

const GallerySection = (props: Props) => {
	const galleryData: MediaGalleryModuleType[] = getPosts(
		"MediaGalleryModule",
		{data: Gallery},
	)

	const categories = galleryData.map((section) => ({
		name: section.title,
		content: section.media,
	}))

	return (
		<ContainerWrapper>
			<Typography
				variant={Variant.SectionTitle}
				content={props.data.sectionTitle}
			/>
			<Typography
				variant={Variant.SectionSubtitle}
				content={props.data.sectionSubtitle}
			/>
			<Separator />
			<ReusableFeaturesGrid<MediaType>
				categories={categories}
				renderItem={(item, index) =>
					item.preview && (
						<div style={{cursor: "pointer"}}>
							<NewResponsiveImage
								{...item.preview}
								style={{aspectRatio: "16/9"}}
								withoutContainer
							/>
						</div>
					)
				}
				renderShadowItem={(item) =>
					item.preview && (
						<NewResponsiveImage
							{...item.preview}
							style={{aspectRatio: "16/9"}}
							withoutContainer
						/>
					)
				}
				renderZoomedContent={(item) =>
					item.preview && <GalleryPopup data={item.preview} />
				}
			/>
		</ContainerWrapper>
	)
}

export default GallerySection
